module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-section repost-price"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "repost-price-select"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.repost_prices,
      "item-text": "name",
      "item-value": "value",
      "label": "Price",
      "content-class": "GLOBAL-repost-price-select",
      "single-line": "",
      "auto": "",
      "dirty": "",
      "text-field": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.repost_price),
      callback: function($$v) {
        _vm.repost_price = $$v
      },
      expression: "repost_price"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "update-btn",
    nativeOn: {
      "click": function($event) {
        _vm.openRepostPriceConfirmModal()
      }
    }
  }, [_vm._v("Set")])], 1), _vm._v(" "), _c('div', {
    staticClass: "repost-price-info-box pa-3 mt-2"
  }, [_c('div', [_vm._v("\n        You've upgraded to\n        "), _c('b', [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.currentUser.max_repost_price)))])]), _vm._v(" "), _c('div', [_vm._v("\n        Upgraded until\n        "), _c('b', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.currentUser.repost_price_end_at)))])])])]), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.show_repost_price_confirm_modal),
      callback: function($$v) {
        _vm.show_repost_price_confirm_modal = $$v
      },
      expression: "show_repost_price_confirm_modal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Upgrade Repost Price")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        In order to upgrade your Repost Price you need to pay an annual fee\n        equal to the price you want to upgrade to."), _c('br'), _vm._v(" "), (_vm.proration.add_amount > 0) ? [_vm._v("You have to pay additional $" + _vm._s(_vm._f("formatNumber")(_vm.proration.add_amount)))] : _vm._e()], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentModal()
      }
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeRepostPriceConfirmModal()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), (_vm.show_payment_modal) ? _c('payment-modal', {
    attrs: {
      "amount": _vm.proration.add_amount,
      "dismiss": _vm.closePaymentModal,
      "finish": _vm.setRepostPrice
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "description-section"
  }, [_c('h3', [_vm._v("Earn money by sharing content")]), _vm._v(" "), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v("\n      Every user can accept $1 and earns 50% of the revenue split."), _c('br'), _vm._v("\n      Upgrade your price to keep 90% of each repost request.\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-3"
  }, [_c('li', [_vm._v("\n        To increase your repost price, you must pay an annual amount equal to\n        the price you want to set"), _c('br'), _vm._v("\n        Example: To charge $20 per repost, you must pay $20 per year\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        If you want to increase your price multiple times within an year, your\n        cost is prorated\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        If you upgrade your price, you can downgrade your price at any time\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7486e837","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/components/price_tab.vue
// module id = 1780
// module chunks = 180